import script from "./MultiVideoLive.vue?vue&type=script&lang=ts&setup=true"
export * from "./MultiVideoLive.vue?vue&type=script&lang=ts&setup=true"

import "./MultiVideoLive.vue?vue&type=style&index=0&id=0b0a6d6a&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b0a6d6a"]])

export default __exports__